<div [formGroup]="form">
	<div class="input-group input-group-sm mb-2">
		<span class="input-group-text">
			<span class="text-danger">*</span>
			To
		</span>
		<tag-input formControlName="toMail" id="toMail" class="form-control"
			[placeholder]="'Please add email address and press space bar.'"
			[secondaryPlaceholder]="'Please add email address and press space bar.'" [separatorKeys]="[' ']"
			[editable]="true" [validators]="emailvalidators" [errorMessages]="emailerrormessages"
			[modelAsStrings]="true" theme="bootstrap" [addOnPaste]="true" [pasteSplitPattern]="splitPattern"
			[separatorKeyCodes]="[13]">
			<tag-input-dropdown [autocompleteItems]="suggestions" [showDropdownIfEmpty]="true">
			</tag-input-dropdown>
		</tag-input>
		<!-- <tag-input formControlName="toMail" id="toMail" class="form-control"
			[placeholder]="'Please add email address and press space bar.'"
			[secondaryPlaceholder]="'Please add email address and press space bar.'" [separatorKeys]="[' ']"
			[editable]="true" [validators]="emailvalidators" [errorMessages]="emailerrormessages"
			[modelAsStrings]="true" theme="bootstrap" [addOnPaste]="true" [pasteSplitPattern]="splitPattern"
			[separatorKeyCodes]="[13]" (onTextChange)="fetchReplyEmails($event,'toMail')"
			[onTextChangeDebounce]="onTextChangeDebounce">
			<tag-input-dropdown [autocompleteItems]="suggestions_to" [showDropdownIfEmpty]="true">
			</tag-input-dropdown>
		</tag-input> -->
	</div>
	<div class="input-group input-group-sm mb-2">
		<span class="input-group-text">
			Cc
		</span>
		<tag-input formControlName="ccMail" id="ccMail" class="form-control"
			[placeholder]="'Please add email address and press space bar.'"
			[secondaryPlaceholder]="'Please add email address and press space bar.'" [separatorKeys]="[' ']"
			[editable]="true" [validators]="emailvalidators" [errorMessages]="emailerrormessages"
			[modelAsStrings]="true" theme="bootstrap" [addOnPaste]="true" [pasteSplitPattern]="splitPattern"
			[separatorKeyCodes]="[13]">
			<tag-input-dropdown [autocompleteItems]="suggestions" [showDropdownIfEmpty]="true">
			</tag-input-dropdown>
		</tag-input>
		<!-- <tag-input formControlName="ccMail" id="ccMail" class="form-control"
			[placeholder]="'Please add email address and press space bar.'"
			[secondaryPlaceholder]="'Please add email address and press space bar.'" [separatorKeys]="[' ']"
			[editable]="true" [validators]="emailvalidators" [errorMessages]="emailerrormessages"
			[modelAsStrings]="true" theme="bootstrap" [addOnPaste]="true" [pasteSplitPattern]="splitPattern"
			[separatorKeyCodes]="[13]" (onTextChange)="fetchReplyEmails($event,'ccMail')"
			[onTextChangeDebounce]="onTextChangeDebounce">
			<tag-input-dropdown [autocompleteItems]="suggestions_cc" [showDropdownIfEmpty]="true">
			</tag-input-dropdown>
		</tag-input> -->
	</div>
	<div class="input-group input-group-sm mb-2">
		<span class="input-group-text">
			<span class="text-danger">*</span>
			Subject
		</span>
		<input class="form-control" formControlName="subject" />
	</div>
	<div class="mb-editor text_editor_container">
		<quill-editor formControlName="body" [modules]="quillConfig" placeholder="Mail body"></quill-editor>
	</div>
</div>